/**
 * 纯函数版设备检测（不写 localStorage，无副作用）。
 *
 * 使用方：official_website_new（设备路由）与 team_join_link（区分 H5 / PC 场景）。
 *
 * 逻辑参考 src/util/utils_cover.js 的 identifyDevicePlatform，去掉 localStorage 写入：
 *  - 高频调用安全（resize 监听里可放心调）
 *  - 不污染全站 localStorage 状态
 *  - 不影响其他页面的 identifyDevicePlatform 使用方
 *
 * 返回：'pad' | 'phone' | 'pc'（异常 UA 兜底返 'pc'）
 */

function isIPadDevice() {
  const u = navigator.userAgent;
  // iPadOS 13+ UA 伪装成 Mac，需结合触摸点；传统 iPad UA 含 'iPad'
  return (
    u.indexOf("iPad") > -1 ||
    (u.indexOf("Macintosh") > -1 && navigator.maxTouchPoints > 0)
  );
}

/**
 * 屏幕物理尺寸 + 触摸点指纹（vivo / 小米 / 华为等国产 Android pad UA 都带 Mobile，
 * 纯 UA 区分不出，加这层硬件指纹兜底）：
 * - 必须支持触摸（排除桌面）
 * - 物理屏短边 ≥ 600（手机 ≤ 480；pad 普遍 ≥ 600，vivo Pad5 Pro ≈ 1200）
 * - 物理屏短边 ≤ 1366（排除桌面 + 大屏一体机）
 */
function isLikelyTabletByScreen() {
  if (typeof window === "undefined" || typeof screen === "undefined") return false;
  const hasTouch = navigator.maxTouchPoints > 0;
  if (!hasTouch) return false;
  const shortSide = Math.min(screen.width, screen.height);
  return shortSide >= 600 && shortSide <= 1366;
}

export function detectDevice() {
  const u = navigator.userAgent;
  const isWindowsPhone = /(?:Windows Phone)/.test(u);
  const isSymbian = /(?:SymbianOS)/.test(u) || isWindowsPhone;
  const isAndroid = /(?:Android)/.test(u);
  const isFireFox = /(?:Firefox)/.test(u);
  const isPad =
    isIPadDevice() ||
    (isAndroid && !/(?:Mobile)/.test(u)) ||
    (isFireFox && /(?:Tablet)/.test(u)) ||
    /* 国产 Android pad（vivo / 小米 / 华为 / OPPO 等）UA 都带 Mobile，
       靠物理屏幕短边 ≥ 600 + 触摸点兜底识别 */
    (isAndroid && isLikelyTabletByScreen()) ||
    /* "请求桌面版" 模式下 UA 不含 Android，仍可能是 pad，靠屏幕指纹兜底 */
    isLikelyTabletByScreen();
  const isPhone = /(?:Phone)/.test(u) && !isPad;

  if (isPad) return "pad";
  if (isAndroid || isPhone) return "phone";
  if (!isPhone && !isAndroid && !isSymbian) return "pc";
  return "pc";
}
